// extracted by mini-css-extract-plugin
export default {"menuSearchAgain":"MealsNotFound-module_menuSearchAgain_IlrrMpk4un","popularRecipeButton":"MealsNotFound-module_popularRecipeButton_VERmRG8SIQ"};